import { size } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  useGetCustomerOrdersQuery,
  useGetSingleCustomerQuery,
} from '../../api/users/userAPI';
import CustomCard2 from '../../components/cards/CustomCard2';
import CustomerDetailsSidebar from '../../components/sidebars/CustomerDetailsSidebar';
import CustomerOrdersTable from '../../components/tables/CustomerOrdersTable';
import { setCustomer, setCustomerOrders } from '../../features/userSlice';
import PageLayout from '../layouts/PageLayout';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';
import DataFetchingFeedback from '../../components/feedbacks/DataFetchingFeedback';

const CustomerDetails = () => {
  const { customer_id } = useParams();
  const dispatch = useDispatch();
  const {
    data: orders,
    isSuccess,
    isError,
    isLoading,
  } = useGetCustomerOrdersQuery(customer_id);
  const { data: customer, isSuccess: success } =
    useGetSingleCustomerQuery(customer_id);

  if (isSuccess) {
    dispatch(setCustomerOrders({ customerOrders: orders.data }));
  }

  if (isError) {
    dispatch(setCustomerOrders({ customerOrders: [] }));
  }

  if (success) {
    dispatch(setCustomer({ customer: customer.data }));
  }

  return (
    <>
      <PageLayout sidebar={<CustomerDetailsSidebar />} head="Customer details">
        <CustomCard2 title={`Customer orders`} height={640}>
          {isLoading ? (
            <DataFetchingFeedback />
          ) : size(orders) === 0 ? (
            <NoDataFeedback message="No order found" />
          ) : (
            <CustomerOrdersTable />
          )}
        </CustomCard2>
      </PageLayout>
    </>
  );
};

export default CustomerDetails;
